import { motion } from "motion/react";
import { HiChatAlt2 } from "react-icons/hi";
import { goInstallChatApp } from "../../services/chatApp";
import { canGetChatApp, useInstallState } from "./InstallGuide";

// Header button that takes people to the installable chat app (IRG Chat). The ERP itself is no longer
// installable. Hidden once the chat app is installed from this browser, or where apps can't be installed.
function InstallAppButton() {
  const { installed } = useInstallState();

  if (installed || !canGetChatApp()) return null;

  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={goInstallChatApp}
      className="h-10 flex items-center gap-2 px-3 rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-sm hover:bg-gray-50 dark:hover:bg-gray-700 text-sm font-medium text-[#2470B7] dark:text-blue-300 transition-colors"
      aria-label="Get the IRG Chat app"
      title="Install IRG Chat, the team chat app"
      data-tour="header-install"
    >
      <HiChatAlt2 className="w-5 h-5" />
      <span className="hidden lg:inline">Get chat app</span>
    </motion.button>
  );
}

export default InstallAppButton;
